import { REACT_GOOGLE_ANALYTICS_MEASUREMENT_ID } from "config";
import ReactGA4 from "react-ga4";

const initializeGA = () => {
  ReactGA4.initialize([
    {
      trackingId: REACT_GOOGLE_ANALYTICS_MEASUREMENT_ID,
      gaOptions: {
        debug_mode: false,
      },
      gtagOptions: {
        debug_mode: false,
      },
    },
  ]);
};

const trackCustomEventGoogleAnalytics = (customEventName: string, params: { [key: string]: any } = {}) => {
  ReactGA4.event(customEventName, params);
};

export { initializeGA, trackCustomEventGoogleAnalytics };
